<template>
<div class="row mt-5">
  <div class="col-xl-5" v-if="checkForPermission(add_delivery_zone_permission)">
    <delivery-zone-form button_text="Add Delivery Zone" @zoneAction="addDeliveryZone"/>
  </div>
  <div class="col-xl-7">
    <TableLoading v-if="zones.page === 0"/>
    <data-table v-else :columns="columns" :rows="zones.objects">
      <template v-slot:actions="slotProps" v-if="checkForPermission(edit_delivery_zone_permission)">
        <b-button v-b-modal.edit-delivery-zone variant="success" size="sm" class="py-1 text-white" @click="selectDeliveryZone(slotProps.row)">
          Edit
        </b-button>
      </template>
    </data-table>
    <b-modal
        id="edit-delivery-zone"
        centered
        size="lg"
        hide-footer
        hide-header
        title-class="font-18">
      <div class="p-2">
        <h3>Edit Delivery Zone</h3>
        <delivery-zone-form button_text="Edit Delivery Zone" :selected_zone="selected_zone" @zoneAction="editDeliveryZone"/>
        <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('edit-delivery-zone')">Close</b-button>
      </div>
    </b-modal>
  </div>
</div>
</template>

<script>
import DeliveryZoneForm from "@/components/settings/delivery-zone-form";
import DataTable from "@/components/data-table";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import {ALL_DELIVERY_ZONES} from "@/gql/system-settings";
import {permissions} from "@/router/permissions";
export default {
name: "delivery-zone-component",
  components: {TableLoading, DataTable, DeliveryZoneForm},
  data(){
    return{
      searchTerm: '',
      selected_zone: {},
      add_delivery_zone_permission: permissions.add_delivery_zone_permission,
      edit_delivery_zone_permission: permissions.edit_delivery_zone_permission,
      columns: [
        {
          field: 'name',
          label: 'Name'
        },
        {
          field: 'location',
          label: 'Location'
        },
        {
          field: 'divider',
          label: 'Divider Road'
        },
        {
          field: 'days',
          label: 'Days'
        },
        {
          field: 'details',
          label: 'Description'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ],
      zones: {
        page: 0,
        objects: []
      },
    }
  },
  apollo: {
    zones: {
      query: ALL_DELIVERY_ZONES,
      variables (){
        return {
          page: 0,
          perPage: 30
        }
      }
    },
  },
  methods: {
    ... mapActions({
      addZone: 'settings/addNewDeliveryZones',
      updateZone: 'settings/updateDeliveryZone'
    }),
    async addDeliveryZone(data){
      await this.addZone(data).then(() => {
        this.updateZones()
        successToast('New zone added successfully')
      })
    },
    async editDeliveryZone(data){
      data.id = this.selected_zone.publicId
      await this.updateZone(data).then(resp => {
        this.updateZones()
        successToast(`${resp.name} updated successfully`)
      })
    },
    selectDeliveryZone(row){
      this.selected_zone = row
    },
    updateZones(){
      this.$apollo.queries.zones.refetch()
    }
  }
}
</script>

<style scoped>

</style>
